import { OrderValidation } from './order.validation';

export class OrderStepChange extends OrderValidation {
  onStep(forms) {
    [...forms].forEach((form) => {
      this.validateForm(form, 'button[type="submit"]');
      form.onsubmit = async (e) => {
        e.preventDefault();
        this.scrollToInvalidInput();
        this.scrollToFormOnMobile();

        if (form.checkValidity()) {
          if (this.TAB_STATES.step !== this.TAB_STATES.lastStep) {
            if (!this.debug) this.nextStep(e.currentTarget, form).disableNonPassedStep();
            this.nextStep(e.currentTarget, form)
              .activateNextStep();
          } else {
            await this.sendForm()
              .then((response) => {
                if (response.status === 201) {
                  const data = this.getJsonStorage();
                  if (data !== null) {
                    data.states.step = 1;
                    this.setStorage(data);
                  }
                  window.location.href = `/cart/order/final/${response.data.id}`;
                } else {
                  this.finalMessage(
                    'Произошла ошибка на сервере',
                    'Попробуйте снова через некоторое время',
                  );
                }
              })
              .catch((error) => {
                this.finalMessage(
                  'Произошла ошибка на сервере',
                  'Попробуйте снова через некоторое время',
                );
                // eslint-disable-next-line no-console
                console.warn(error);
              });
          }
        }
      };
    });
    return this;
  }

  /**
   * @param {HTMLElement} button
   * @param {HTMLFormElement} form
   */
  nextStep(button, form) {
    const nextStep = this.order.querySelector(`[data-step="${(this.TAB_STATES.step + 1)}"]`);
    this.TAB_STATES.opened += 1;

    if (nextStep !== null && nextStep.classList.contains('skip')) {
      this.TAB_STATES.step += 2;
    }

    return this;
  }

  listenClickStep() {
    const tabs = this.order.children;

    Array.prototype.filter.call(tabs, (tab) => {
      tab.addEventListener('click', (e) => {
        const isDeliveryShopSelf = this.order.querySelector('input[name="delivery_method"][value="1"]')?.checked;
        if (isDeliveryShopSelf) {
          this.insetToContactsSelfShop();
          document.querySelector('[data-delivery-text]').classList.remove('d-flex');
          document.querySelector('[data-delivery-text]').classList.add('d-none');
        } else {
          document.querySelector('[data-delivery-text]').classList.remove('d-none');
          document.querySelector('[data-delivery-text]').classList.add('d-flex');
        }

        const findInvalid = this.order.querySelector('form:invalid');

        if (findInvalid !== null) {
          const invalidId = Number(e.target.closest('.card').dataset.step);
          const activeId = Number(this.order.querySelector('.card.active').dataset.step);
          const validate = !this.debug
            && (invalidId > activeId && e.target.dataset.target !== `#step-${invalidId}`)
            && e.target.classList.contains('btn-link');
          if (validate) {
            e.stopPropagation();
          }
        }

        this.TABS.find(tabParams => tabParams.active === true).active = false;
        this.TAB_STATES.step = Number(e.currentTarget.dataset.step);
        this.TABS[this.TAB_STATES.step - 1].active = true;
        this.changeStepsCounters();
        const event = document.createEvent('Event');
        event.initEvent('Order:update', true, true);
        this.order.dispatchEvent(event);
      });
    });

    return this;
  }

  /**
   * @param {Number} stepNum
   * @param {Number} nextStepNum
   * @param {boolean} state
   * @returns {OrderFormBySteps}
   */
  skipStep(stepNum, nextStepNum, state) {
    if (state) {
      this.TABS[stepNum - 1].invalid = false;
      this.order.querySelector(`[data-step="${stepNum}"]`).classList.remove('invalid');
      this.order.querySelector(`[data-step="${stepNum}"]`).classList.add('skip');
      this.TABS[stepNum - 1].disabled = true;
      this.order.querySelector(`#step-${stepNum - 1} .btn-danger`)
        .dataset.target = '#step-5';
    } else {
      this.order.querySelector(`[data-step="${stepNum}"]`).classList.remove('skip');
      this.TABS[stepNum - 1].disabled = false;
      this.order.querySelector(`#step-${stepNum - 1} .btn-danger`)
        .dataset.target = '#step-4'; // Тут убрал пока переменную
    }

    this.DataForm = this.order.querySelector(`#step-${stepNum} form`);
    return this;
  }

  /**
   * @description Save data to LocalStorage on collapse and update 5 step info
   */
  collapseListen() {
    const tabs = this.order.children;

    Array.prototype.filter.call(tabs, (tab) => {
      $(tab).on('shown.bs.collapse', () => {
        $('html, body').animate({
          scrollTop: $(tab).offset().top - 180,
        }, 600);
        this.TAB_STATES.step = Number(tab.dataset.step);
        const LocalData = {
          data: this.getJsonData(),
          states: this.TAB_STATES,
        };
        this.setStorage(LocalData);
      });

      $(tab).on('hidden.bs.collapse', () => {
        if (!tab.classList.contains('disabled')) {
          this.pasteUserInfoToFastForm('#modalFastOrder form');
          this.manualResetDisabled();
          this.DataForm = tab.querySelector('form');
          tab.querySelector('form').classList.remove('was-validated');
          this.showResultInfo();
        }
      });
    });
  }
}
